import { render, staticRenderFns } from "./LeaveDetail.vue?vue&type=template&id=2405820b"
import script from "./LeaveDetail.vue?vue&type=script&lang=js"
export * from "./LeaveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports